<template>
  <div>
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>
          <b-row>
            <b-col lg="10">
              <h2 class="mb-2">
                {{ $t("pharmacy.Patient Card Pharmacy Details") }}
              </h2>
            </b-col>
            <!-- <b-col lg="2">
              <b-button
                @click="show(patientCardData)"
                variant="warning"
                class="p-1 mb-1"
                block
              >
                {{ $t('common.Edit Patient Card') }}
              </b-button>
            </b-col> -->
          </b-row>
          <div>
            <h5 class="my-2">
              <b> {{ $t("common.patient-name") }}:</b>
              <p class="mx-2 d-inline d-inline" v-if="patientCardData.patient">
                {{ patientCardData.patient.name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b> {{ $t("emergency.Companinon name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ patientCardData.full_companion_name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b> {{ $t("emergency.Companinon Phonenumber") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.companion_phone }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("common.type") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.type }}</p>
            </h5>

            <h5 class="my-2">
              <b> {{ $t("emergency.Patient Case") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.patient_case }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("emergency.Patient Case Details") }}:</b>
              <p class="mx-2 d-inline">
                {{ patientCardData.patient_case_details }}
              </p>
            </h5>
          </div>

          <hr class="invoice-spacing" />
          <h2 class="my-2">{{ $t("emergency.Patient Updates") }}</h2>
          <div>
            <h5 class="my-2">
              <b>{{ $t("common.Date of Last Update") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.updated_at }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("common.Info Created At") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.created_at }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.card-no") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.card_no }}</p>
            </h5>
          </div>
          <hr class="invoice-spacing" />
        </b-card>
      </b-col>
    </b-row>

    <PatientDrug
      :patientCardId="patientCardData.id"
      v-if="
        patientCardData.type == 'IN' ||
        patientCardData.type == 'EMERGENCY' ||
        patientCardData.type == 'Clinic' ||
        patientCardData.type == 'OUT' ||
        patientCardData.type == 'LAB'
      "
      :show-dispense="true"
    />
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner label="Loading..." />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import ReceptionHistoryCard from "@/components/reception/ReceptionHistoryCard";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PateintCardTest from "@/views/lab/PatientCardTest.vue";
import PatentCardSurgery from "@/views/surgery/PatientSurgery.vue";
import PatientCardRadiology from "@/views/radiology/PatientCardRadiology.vue";
import PatientOutClinicInvoice from "@/views/Reception/PatientOutClinicInvoice.vue";
import SurgeryInsuranceInvoice from "@/views/surgery/SurgeryInsuranceInvoice.vue";
import PatientEmergency from "@/views/emergency/PatientEmergency.vue";
import PatientDrug from "@/views/pharmacy/PatientDrug.vue";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BCard,
    BCardText,
    BButton,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    StatisticCardHorizontal,
    AutoComplete,
    vSelect,
    ToastificationContent,
    PateintCardTest,
    PatentCardSurgery,
    PatientCardRadiology,
    PatientOutClinicInvoice,
    SurgeryInsuranceInvoice,
    PatientEmergency,
    VuePhoneNumberInput,
    PatientDrug,
    BSpinner
  },
  data() {
    return {
      loading: false,
      params: {
        form: {},
        path: "",
      },
      EditForm: {
        full_companion_name: "",
        companion_phone: "",
        patient_case_details: "",
        type: "",
        patient_id: "",
        _method: "PUT",
      },
      patientCardData: {},
      patientTest: {},
      patientTestForm: {
        patient_card_id: "",
        tests: [],
        _method: "PUT",
      },
      typeList: [
        {
          text: "Type 1",
          value: "0",
        },
        {
          text: "Type 2",
          value: "1",
        },
      ],
      patientRadiology: {},
      patientRadiologyForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
        _method: "PUT",
      },
    };
  },
  mounted() {
    this.getPatientCard();
  },

  methods: {
    show(item) {
      this.EditForm.id = item.id;
      this.EditForm.full_companion_name = item.full_companion_name;
      this.EditForm.companion_phone = item.companion_phone;
      this.EditForm.patient_case_details = item.patient_case_details;
      this.EditForm.patient_id = item.patient_id;
      this.EditForm.type = item.type;
      this.EditForm._method = "PUT";
      this.$bvModal.show("modal-edit-patient-card");
    },

    EditPatientCard() {
      (this.params.form = this.EditForm),
        (this.params.path = `/patientCard/${this.EditForm.id}`),
        this.$store
          .dispatch("update", this.params)
          .then((response) => {
            this.getPatientCard();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Card Edited",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },

    async getPatientCard() {
      this.loading = true;
      await this.getPatient(
        `active-card/patient/${this.$route.params.id}?include=patient,drugs&sort=-created_at`
      );
      this.loading = false;

      this.patientCardData = this.all_data.data;
    },
  },
};
</script>
